// extracted by mini-css-extract-plugin
module.exports = {"pintxo-avatar":"Avatar_pintxo-avatar__d2iN_","pintxo-avatar__shape":"Avatar_pintxo-avatar__shape__5shRs","pintxo-avatar__shape__text":"Avatar_pintxo-avatar__shape__text__Ze6rb"};